export default {
  title: 'Bestellungen',
};
